module.exports = __webpack_public_path__ + "img/laravel-fullstack-app1.d3c471f2.png";